import { Stack } from "@mui/material";
import { TriangleAlert } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { Callout } from "web_myplann/Shared/Components/Callout";

const PageResources = Resources.Inspiration.OwnHome.RatesUnavailable;

export const OwnHomeRatesUnavailable: FC = () => {
	const { t } = useResource();

	return (
		<Stack px={1.6} pt={1.6}>
			<Callout
				color="amber"
				icon={TriangleAlert}
				title={t(PageResources.title)}
				description={t(PageResources.description)}
			/>
		</Stack>
	);
};
